/**
 * Shared class helpers for the top-bar pill icon buttons so the notifications
 * trigger (which owns its own dropdown/drawer) stays visually identical to
 * the plain NavPillButton siblings inside a cluster.
 */
export const pillButtonBase =
  "relative w-9 h-9 rounded-full flex items-center justify-center transition-colors";

export const pillButtonTone = (isDark) =>
  isDark
    ? "text-surface/80 hover:bg-surface/[0.16] hover:text-surface"
    : "text-secondary hover:bg-surface hover:text-primary hover:shadow-sm";

/** Numeric count badge anchored to the top-end corner of a pill button. */
export const pillBadgeClass = (isDark) =>
  `absolute -top-1 -end-1 min-w-[17px] h-[17px] px-1 rounded-full bg-danger text-surface text-[10px] font-bold flex items-center justify-center leading-none border-2 ${
    isDark ? "border-chrome" : "border-surface"
  }`;
